define.alias("shared/components/shared/plan-recommendation/progress-bar", "calendar/components/shared/plan-recommendation/progress-bar");